module.exports = __webpack_public_path__ + "static/media/suedvers_logo.7eeca289.jpg";